export const CONTACT_SUPPORT_LINK =
  '/requests/new?ticket_form_id=360000390393&insightsapp=&is_verified=false';

export const CUSTOM_PRICING = 'https://www.hotjar.com/pricing/#custom-package';
